export default "__VITE_ASSET__1ad1a0ec__"